const initialState = {
  banners: []
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'receiveBannerData':
      const banners = action.payload
      return {
        ...state,
        banners
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./common/reducers/marketing.js